export interface IAlert {
  date: Date;
  message: string;
}

export class Alert implements IAlert {
  date: Date = new Date();
  message: string;

  constructor(text: string) {
    this.message = text;
  }
}
